<template>
  <div class="ioc-alarm__warp realTimeAlarm-page">
    <alarmToolbar ref="alarmToolbar" @levelClick="alarmLevelClick" :levelNums="levelNums"></alarmToolbar>
    <!-- 告警列表数据 -->
    <alarmList ref="alarmList" :data="cacheAlarmList" @handleIsShow="handleIsShowList" @handleClickAlarm="handleClickAlarm" @nextPage="loadMoreAlarm" @rightClick="handRightClick" @handleAddAlarm="handleAddAlarm" @resetError="resetError" @searchBtn="handleSearchBtn" />
    <!--设备资源数据-->
    <div :class="['alarmTool', !showAlarmTool ? 'show' : '']">
      <div class="alarmTool-btn">
        <el-tooltip class="item" effect="dark" :content="!showTool ? '显示设备资源' : '隐藏设备资源'" placement="top">
          <el-button type="text" class="icon iconfont-lunan icon-lunan-zichanxunjian font-18" @click="showTool = !showTool"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="!showGatePanel ? '显示闸机通行记录' : '隐藏闸机通行记录'" placement="top">
          <el-button type="text" @click="handleShowGate" class="icon iconfont-add iconline-132 font-18"></el-button>
        </el-tooltip>
      </div>
      <div class="alarmTool-list flex-row" v-show="showTool">
        <div v-for="item in alarmToolList" :key="item.value" :class="[
            'alarmTool-list_' + item.img,
            item.isShow ? 'active' : 'inactive',
          ]" @click="handleShowTool(item)">
          <el-tooltip class="item" effect="dark" :content="(!item.isShow ? '显示' : '隐藏') + item.name" placement="top">
            <i :class="'font-24 ' + item.icon"></i>
          </el-tooltip>
        </div>
      </div>
      <div v-show="showToolHide" class="alarmTool-broadcast">
        <!-- 广播喊话 -->
        <div class="alarmTool-call intercom map-blur-panel__title" style="z-index: 3">
          <div class="intercom-title">
            远程喊话【{{
              remoteCallInfo.processing ? "正在喊话" : "暂停喊话"
            }}】
          </div>
          |
          <template v-if="remoteCallInfo.deviceList && remoteCallInfo.deviceList.length">
            <div class="intercom-device" @mouseover="remoteCallInfo.showDeviceList = true" @mouseout="remoteCallInfo.showDeviceList = false">
              <div class="intercom-device-item click-able">
                <i class="iconfont-lunan icon-lunan-radio"></i>
                <div :title="remoteCallInfo.deviceList[0].name" class="device-name" @click="handleMapCenter(remoteCallInfo.deviceList[0])">
                  {{ remoteCallInfo.deviceList[0].name }}
                </div>
                <i v-if="remoteCallInfo.deviceList.length > 1" class="el-icon-caret-bottom device-expand-icon" :class="{
                    expand: remoteCallInfo.showDeviceList,
                  }"></i>
              </div>
              <div class="device-list-area bottom map-blur-panel__title" :style="{
                  height: (remoteCallInfo.deviceList.length - 1) * 30 + 'px',
                }" :class="{ hidden: !remoteCallInfo.showDeviceList }">
                <el-scrollbar style="height: 100%">
                  <template v-for="(item, index) in remoteCallInfo.deviceList">
                    <div v-if="index !== 0" class="intercom-device-item click-able" :key="'intercom-device-' + index" :title="item.name" @click="handleMapCenter(item)">
                      <i class="iconfont-lunan icon-lunan-radio"></i>
                      <div class="device-name" :title="item.name">
                        {{ item.name }}
                      </div>
                    </div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
            <div class="intercom-operate">
              <div class="click-able operate-btn" @click="toggleStopIntercom">
                <el-tooltip :content="remoteCallInfo.processing ? '停止喊话' : '继续喊话'" effect="dark" placement="top">
                  <i :class="
                      remoteCallInfo.processing
                        ? 'el-icon-video-pause play-icon'
                        : 'el-icon-video-play stop-icon'
                    "></i>
                </el-tooltip>
              </div>
            </div>
            <div class="intercom-volume" :class="{ 'click-able': remoteCallInfo.processing }" @mouseover="remoteCallInfo.showVolume = remoteCallInfo.processing" @mouseout="remoteCallInfo.showVolume = false">
              <div class="intercom-volume-bar active">
                <el-slider v-model="remoteCallInfo.broadcastVolume" :max="15" @change="
                    (val) => {
                      handleVoice(val, remoteCallInfo.deviceList);
                    }
                  "></el-slider>
              </div>
              <i class="iconfont-lunan icon-lunan-guangbo"></i>
            </div>
            <el-tooltip content="关闭喊话" effect="dark" placement="top-start">
              <div class="intercom-close click-able" @click="handleClosePlay(1)">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <div class="intercom-device">
              <div class="device-name">无广播设备</div>
            </div>
          </template>
        </div>
        <!-- 播放音频 -->
        <div class="alarmTool-call intercom map-blur-panel__title">
          <div class="intercom-title">
            播放音频【{{
              audioDeviceInfo.processing ? "正在播放" : "暂停播放"
            }}】
          </div>
          |
          <template v-if="
              audioDeviceInfo.deviceList && audioDeviceInfo.deviceList.length
            ">
            <div class="intercom-device" @mouseover="audioDeviceInfo.showDeviceList = true" @mouseout="audioDeviceInfo.showDeviceList = false">
              <div class="intercom-device-item click-able">
                <i class="iconfont-lunan icon-lunan-radio"></i>
                <div :title="audioDeviceInfo.deviceList[0].name" class="device-name" @click="handleMapCenter(audioDeviceInfo.deviceList[0])">
                  {{ audioDeviceInfo.deviceList[0].name }}
                </div>
                <i v-if="audioDeviceInfo.deviceList.length > 1" class="el-icon-caret-bottom device-expand-icon" :class="{
                    expands: audioDeviceInfo.showDeviceList,
                  }"></i>
              </div>
              <div class="device-list-area bottom map-blur-panel__title" :style="{
                  height: (audioDeviceInfo.deviceList.length - 1) * 30 + 'px',
                }" :class="{ hidden: !audioDeviceInfo.showDeviceList }">
                <el-scrollbar style="height: 100%">
                  <template v-for="(item, index) in audioDeviceInfo.deviceList">
                    <div v-if="index !== 0" class="intercom-device-item click-able" :key="'intercom-device-' + index" :title="item.name" @click="handleMapCenter(item)">
                      <i class="iconfont-lunan icon-lunan-radio"></i>
                      <div class="device-name" :title="item.name">
                        {{ item.name }}
                      </div>
                    </div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
            <div class="intercom-operate">
              <template>
                <div class="audio-button">
                  <el-tooltip content="上一首" effect="dark">
                    <i class="click-able el-icon-arrow-left audio-button" @click="controlPlayAudio('previous')"></i>
                  </el-tooltip>
                  <el-tooltip :content="audioDeviceInfo.processing ? '暂停' : '播放'" effect="dark">
                    <i @click="
                        controlPlayAudio(
                          audioDeviceInfo.processing ? 'pause' : 'play'
                        )
                      " class="click-able audio-button" :class="
                        audioDeviceInfo.processing
                          ? 'el-icon-video-pause play-icon'
                          : 'el-icon-video-play stop-icon'
                      "></i>
                  </el-tooltip>
                  <el-tooltip content="下一首" effect="dark">
                    <i class="click-able el-icon-arrow-right audio-button" @click="controlPlayAudio('next')"></i>
                  </el-tooltip>
                </div>
              </template>
            </div>
            <div class="intercom-volume" :class="{ 'click-able': audioDeviceInfo.processing }" @mouseover="
                audioDeviceInfo.showVolume = audioDeviceInfo.processing
              " @mouseout="audioDeviceInfo.showVolume = false">
              <div class="intercom-volume-bar active">
                <el-slider v-model="audioDeviceInfo.broadcastVolume" :max="15" @change="
                    (val) => {
                      handleVoice(val, audioDeviceInfo.deviceList);
                    }
                  "></el-slider>
              </div>
              <i class="iconfont-lunan icon-lunan-guangbo"></i>
            </div>
            <el-tooltip content="关闭音频" effect="dark" placement="bottom">
              <div class="intercom-close click-able" @click="handleClosePlay(2)">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <div class="intercom-device">
              <div class="device-name">无广播设备</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 手动告警 -->
    <div class="ioc-alarm__drawer" :class="{ expand: showAddAlarmPanel }">
      <handleAlarm ref="handleAlarm" @cancelAlarm="handleCloseAdd" :handleAlarmType="handleAlarmType" :upDeviseData="upDeviseData"></handleAlarm>
    </div>
    <!-- 告警详情-操作数据 -->
    <alarmDetailNew :currentAlarmDetail="currentAlarmDetail" :workerOrderList="workerOrderList" :deviceTableData="deviceTableData" :isShowPanel="isShowPanel" @resetDispose="resetDispose" @handleTaskInfoCallBack="handleTaskInfoCallBack" @handleLayer="handleLayer" @handleCloseAlarm="handleCloseAlarm" @handleOpenBroadcast="handleOpenBroadcast" />
    <!-- 人行闸机数据 -->
    <gate ref="refGate" :showGatePanel="showGatePanel" @handleCloseGate="handleShowGate" :sceneCode="sceneCode" />
    <!-- 楼栋楼层数据 -->
    <floor ref="floorDraw" @handleCloseFloor="handleCloseFloor" />
    <!--远程喊话,播放音频-->
    <Broadcast ref="refBroadcast" :broadcastPageType="broadcastPageType" :refMap="refMap" :layerId="constLayerId.broadcast" :showPanel="showBroadcast" :broadcastArray="constList.broadcast" @handleCloseBroadcast="handleCloseBroadcast" @handleSuccessBroadcast="handleSuccessBroadcast" />
    <!-- 出入口场景 -->
    <getWayScene v-if="showGetWayScene" @resetDispose="resetDispose" @handleCloseScene="handleCloseScene" @handleShowGateDetail="handleShowGateDetail" :sceneCode="sceneCode" :sceneType="sceneType" />
    <!-- 误报原因--忽略原因 -->
    <el-dialog :title="dialogTitle" :visible.sync="errorDialogShow" width="550px" append-to-body :before-close="errorClose">
      <el-form :rules="rules" class="dialogForm" ref="dialogForm" :model="formDialog">
        <el-form-item label="事件确认" prop="confirmType">
          <el-radio-group v-model="formDialog.confirmType" v-if="!isMerge && currentAlarmDetail">
            <el-radio :label="1" v-if="
                currentAlarmDetail.alarmState == 6 ||
                currentAlarmDetail.alarmState == 10 ||
                currentAlarmDetail.alarmState == 1
              ">处理完成</el-radio>
            <el-radio :label="2" v-if="
                currentAlarmDetail.alarmState == 1 ||
                currentAlarmDetail.alarmState == 4
              ">误报事件</el-radio>
          </el-radio-group>
          <el-radio-group v-model="formDialog.confirmType" v-if="isMerge">
            <el-radio :label="2">误报事件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注说明" prop="processDesc">
          <el-input type="textarea" :rows="3" maxlength="200" show-word-limit :placeholder="'请输入备注说明'" v-model="formDialog.processDesc">
          </el-input>
        </el-form-item>
      </el-form>
      <div style="line-height: 25px; padding: 5px; color: #c1c1c1">
        提示： 事件结束后不允许再处理，事件和工单处理记录可在事件档案中查看
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="errorClose">取消</el-button>
        <el-button type="primary" @click="errorSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import alarmToolbar from "@src/components/business/app-alarm/alarmToolbar.vue";
import handleAlarm from "../components/handleAlarm";
import getWayScene from "../components/getWayScene";
import alarmList from "../components/alarmList";
import alarmDetailNew from "../components/alarm-detailNew";
import Broadcast from "../components/broadcast";
import gate from "../components/gate";
import floor from "../components/floor";
import { api } from "../api";
import { mapState } from "vuex";
import floorDetails from "@src/modules/electronicPatrol/components/floorDetails.vue";
import { Dic } from "$utils";
import Vue from "vue";
import { mapMutations } from "vuex";
export default {
  components: {
    alarmToolbar,
    alarmList,
    alarmDetailNew,
    gate,
    floor,
    Broadcast,
    getWayScene,
    handleAlarm,
  },
  data() {
    return {
      disposeType: "", //关闭来源
      sceneType: 1, //1出入口场景，2 告警
      levelNums: {},
      showAddAlarmPanel: false,
      upDeviseData: {},
      handleAlarmType: 1, //告警/2修改坐标
      refMap: null,
      page: {
        pageSize: 30,
        currentPage: 1,
        total: 0,
      },
      devicePage: {
        countPage: 5,
        pageSize: 20,
        currentPage: 1,
        total: 0,
        layout: " prev, pager, next",
      },
      broadcastPageType: 2, //1广播喊话，2 播放音频
      showAlarmTool: true,
      showTool: true,
      isShowPanel: false, //右侧详情
      showGatePanel: false, //人行道闸列表
      showBroadcast: false, //广播喊话
      showGetWayScene: false, //场景配置
      hideCamera: true,
      alarmToolList: [
        {
          name: "摄像机",
          img: "camera",
          icon: "iconfont-lunan icon-lunan-shexiangtou",
          isShow: false,
          layerId: "CAMERA_LAYER",
          value: 0,
        },
        {
          name: "出入口",
          img: "getway",
          layerId: "SET_SCENE",
          icon: "iconfont-lunan icon-lunan-u20",
          isShow: true,
          value: 1,
        },
        // {
        //   name: "广播",
        //   img: "broadcast",
        //   layerId: "BROAD_CAST_LAYER",
        //   icon: "iconfont-lunan icon-lunan-guangbo",
        //   isShow: true,
        //   value: 2,
        // },
      ],
      // 隐藏喊话
      showToolHide: false,
      queryParams: {
        alarmLevel: "", //级别
        alarmTypeList: [], //子系统类型
        alarmMergeCodeList: [], //合并列表
        subSystemList: _.map(Dic.find("SENU004"), "value"), //子系统类型
        deviceName: "",
        alarmName: "",
        alarmStartTime: "",
        alarmEndTime: "",
      },
      allSubSystemList: _.map(Dic.find("SENU004"), "value"), //子系统类型,
      cacheAlarmList: [],
      currentAlarmDetail: null,
      alarm: {
        alarmId: "",
        processDesc: "",
        alarmState: "",
      },
      alarmType: "",
      workerOrderList: [],
      deviceTableData: [],
      broadcastSrc: "images/theme/newDark/map/resource/broadcast_inactive.png", //默认广播
      broadcastCheckSrc: "images/theme/newDark/map/resource/broadcast-call.png", //广播喊话
      broadcastCheckPlaySrc:
        "images/theme/newDark/map/resource/broadcast-audio.png", //音频播放
      constLoading: {
        call: false,
      },
      constLayerId: {
        broadcast: "BROAD_CAST_LAYER",
        camera: "CAMERA_LAYER",
        setScene: "SET_SCENE",
        floor: "FLOOR_LAYER",
        alarm: "MAP_LAYER_DeviceList",
        positionMarkerId: "positionMarkerId",
      },
      constList: {
        broadcast: [],
        camera: [],
        floor: [],
        setScene: [],
      },
      resetErrorType: "", //有数据代表批量
      errorDialogShow: false,
      dialogTitle: "误报",
      isMerge: false,
      remoteCallInfo: {
        // 远程喊话设备
        isEmpty: false,
        deviceList: [],
      },
      audioDeviceInfo: {
        // 播放音频设备
        isEmpty: false,
        deviceList: [],
      },
      formDialog: {
        confirmType: "",
        ignoreText: "",
      },
      rules: {
        confirmType: [
          { required: true, message: "请选择事件类型", trigger: "change" },
        ],
      },
      sceneCode: "", //场景id
    };
  },

  computed: {
    ...mapState({
      alarmNewList: (state) => state.ioc.alarmNewList,
      // alarmCount: (state) => state.ioc.alarmCount,
    }),
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
  },
  watch: {
    // alarmCount(newVal) {
    //   console.log("告警");
    //   // let count = {
    //   //   1: 0,
    //   //   2: 0,
    //   //   3: 0,
    //   //   4: 0,
    //   // };
    //   // _.map(newVal, (item) => {
    //   //   count[parseInt(item.key)] += parseInt(item.value);
    //   // });
    //   // this.levelNums = Object.freeze(count);
    // },
    // 接收websocketor推送的告警
    alarmNewList(newVal) {
      if (newVal) {
        this.getList(this.page, this.queryParams);
      }
    },
    // 告警刷新 闪烁数据刷新
    cacheAlarmList(newVal, oldVal) {
      // console.log("告警数据", newVal);
      this.flickerDeviceList = [];
      // this.cacheAlarmList.map((alarm) => {
      newVal.map((alarm) => {
        if (!alarm.deviceName || !alarm.lat || !alarm.lng) {
          return;
        }
        let tempDeviceIndex = this.flickerDeviceList.findIndex(
          (item) => item.deviceName == alarm.deviceName
        );
        // 已有设备 但是当前告警级别更高
        let tempAlarmIndex = this.flickerDeviceList.findIndex(
          (item) =>
            item.deviceName == alarm.deviceName &&
            item.alarmLevel > alarm.alarmLevel
        );
        // 无当前设备告警
        if (tempDeviceIndex == -1) {
          this.flickerDeviceList.push(alarm);
        } else if (tempAlarmIndex > -1) {
          this.flickerDeviceList[tempAlarmIndex] = alarm;
        }
      });
      // 赋值点位数据
      // this.getFlickerDrawPoint(this.cacheAlarmList);
      this.getFlickerDrawPoint(newVal);
    },
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D(this.initPage);
    this.removeFromAlarmList();
  },
  methods: {
    ...mapMutations({
      addToAlarmList: "ADD_ALARM_TO_LIST",
      removeFromAlarmList: "REMOVE_ALARM_FROM_LIST",
    }),
    alarmLevelClick(level) {
      this.handleSearchTypeLever(level, 2);
      // this.getList(this.page, this.queryParams);//和下方级别功能重复，暂时取消
    },
    initPanel() {
      this.isShowPanel = false;
      this.refMap.removePopup("range_popup");
    },
    handleSearchTypeLever(val, type) {
      // console.log('---主页面val-----', val);
      // console.log('====type=-====', type);
      // 1子系统类型  2级别 3 子系统
      this.page.currentPage = 1;
      this.initPanel();
      this.showType = 2;
      if (type == "1") {
        // 子系统类型
        this.queryParams.subSystemList = [];
        this.queryParams.alarmTypeList[0] = val;
      } else if (type == "2") {
        // 级别
        this.queryParams.alarmLevel = val;
      } else {
        // 子系统
        this.queryParams.subSystemList = [];
        if (Array.isArray(val)) {
          this.queryParams.subSystemList = val;
          this.queryParams.alarmTypeList = [type];
        } else {
          this.queryParams.subSystemList[0] = val;
          this.queryParams.alarmTypeList = [type];
        }
      }
      this.getList(this.page, this.queryParams);
    },
    initPage() {
      this.refMap = this.$map.MapInstance2D;
      // 请求左侧列表
      this.getList(this.page, this.queryParams);
      // 初始化地图资源
      this.initMapResources();
      // 判断路由是否有参数
      if (!_.isEmpty(this.$route.query)) {
        this.handleClickAlarm(this.$route.query);
      }
    },
    initMapResources() {
      // Promise.all([
      //   this.getRemoteCall(), //获取远程喊话
      //   this.getAudioDevice(), //获取播放音频设备
      //   this.getBroadcastList(), //广播设备
      // ]).then((res) => {
      //   this.handleAddMarkBroadcast();
      // });
      this.getCameraList(); //摄像机
      this.getDeviceSceneList(); //场景配置（道闸）
      this.getFloorList(); //楼栋
    },
    getAudioDevice() {
      return new Promise((resolve) => {
        this.$fetch(api.queryPlayAudio).then((res) => {
          if (res.success) {
            let result = res.returnObj || {};
            let deviceList = (result.terminalInfoList || []).map((item) => {
              return {
                id: item.terminalId,
                name: item.terminalName,
                longitude: item.longitude,
                latitude: item.latitude,
              };
            });
            this.audioDeviceInfo = {
              isEmpty: deviceList.length > 0 ? true : false,
              processing: result.controlType && result.controlType != "pause",
              showVolume: false,
              broadcastVolume: 30,
              showDeviceList: false,
              deviceList: deviceList,
              sourceId: result.sourceTerminalId,
              sourceName: result.sourceTerminalName,
              audioList: [],
              audioIndex: 0,
            };
            resolve(true);
          } else {
            resolve(true);
            this.$message.error(res.msgContent);
            this.audioDeviceInfo.isEmpty = false;
          }
        });
      });
    },
    // 获取远程喊话
    getRemoteCall() {
      return new Promise((resolve) => {
        this.$fetch(api.queryRemoteCall).then((res) => {
          if (res.success) {
            let result = res.returnObj || {};
            let deviceList = (result.targetTerminalInfoList || []).map(
              (item) => {
                return {
                  id: item.targetTerminalId,
                  name: item.targetTerminalName,
                  longitude: item.longitude,
                  latitude: item.latitude,
                };
              }
            );
            this.remoteCallInfo = {
              isEmpty: deviceList.length > 0 ? true : false,
              processing: result.stop === "0",
              showVolume: false,
              broadcastVolume: 30,
              showDeviceList: false,
              deviceList: deviceList,
              sourceId: result.sourceTerminalId,
              sourceName: result.sourceTerminalName,
            };
            resolve(true);
          } else {
            this.$message.error(res.msgContent);
            this.remoteCallInfo.isEmpty = false;
            resolve(true);
          }
        });
      });
    },
    // getDeviceSceneList() {
    //   this.constList.setScene = [];
    //   this.$fetch(api.queryDeviceSceneList, {
    //     pageNum: 1,
    //     pageSize: 1000,
    //   }).then((res) => {
    //     if (res.success) {
    //       ((res.returnObj && res.returnObj.list) || []).forEach((item) => {
    //         item.deviceType = "22";
    //         this.constList.setScene.push({
    //           id: item.sceneCode,
    //           coord: [Number(item.longitude), Number(item.latitude)],
    //           anchor: [22, 22],
    //           scale: 1,
    //           src: `images/theme/${this.currentTheme}/map/gate.png`,
    //           sleSrc: `images/theme/${this.currentTheme}/map/gate.png`,
    //           attr: item,
    //           tipsTitle: "出入口详情",
    //           showTips: true,
    //           isHover: true,
    //           upDevice: true,
    //           tipsMap: {
    //             deviceName: "闸机名称",
    //             areaName: "所属区域",
    //             statusName: "状态",
    //             factoryName: "厂家",
    //             createrTime: "创建时间",
    //           },
    //         });
    //       });
    //       this.refMap.addMarket(
    //         this.constList.setScene,
    //         this.constLayerId.setScene,
    //         this.handleMapSceneClick
    //       );
    //     } else {
    //       this.$message.error(res.msgContent || "查询出入口设备列表失败");
    //     }
    //   });
    // },
    getDeviceSceneList() {
      this.constList.setScene = [];
      this.$fetch(api.bms.getDeviceListByPage, {
        deviceType: 25,
        isIndoor: 0,
        page: 1,
        pageSize: 2000,
      }).then((res) => {
        if (res.success) {
          ((res.returnObj && res.returnObj.list) || []).forEach((item) => {
            item.deviceType = "25";
            this.constList.setScene.push({
              id: item.deviceId,
              coord: [Number(item.longitude), Number(item.latitude)],
              anchor: [22, 22],
              scale: 1,
              src: `images/theme/${this.currentTheme}/map/gate.png`,
              sleSrc: `images/theme/${this.currentTheme}/map/gate.png`,
              attr: item,
              tipsTitle: "出入口详情",
              showTips: true,
              isHover: true,
              upDevice: true,
              tipsMap: {
                deviceName: "闸机名称",
                areaName: "所属区域",
                statusName: "状态",
                factoryName: "厂家",
                createrTime: "创建时间",
              },
            });
          });
          this.refMap.addMarket(
            this.constList.setScene,
            this.constLayerId.setScene,
            this.handleMapClick
          );
        } else {
          this.$message.error(res.msgContent || "查询出入口设备列表失败");
        }
      });
    },
    getFloorList() {
      let params = {
        pageFlag: false,
        buildingType: 1, //1楼栋2楼层
      };
      this.constList.floor = [];
      this.$fetch(api.queryBuildingList, params).then((res) => {
        if (res.success) {
          this.constList.floor = res.returnObj;
          let addMarkInfo = res.returnObj.map((item) => {
            return {
              id: item.buildingCode,
              longitude: Number(item.lng),
              latitude: Number(item.lat),
              coord: [Number(item.lng), Number(item.lat)],
              anchor: [20, 20],
              scale: 1,
              isHover: true,
              src: "/images/theme/newDark/map/floor-InActive.png",
              sleSrc: "/images/theme/newDark/map/floor-Active.png",
              attr: {
                ...item,
              },
            };
          });
          this.refMap.addMarket(
            addMarkInfo,
            this.constLayerId.floor,
            this.handleMapFloorClick
          );
        } else {
          this.$message.error(res.msgContent || "查询楼栋数据出错");
        }
      });
    },
    getBroadcastList() {
      this.constList.broadcast = [];
      return new Promise((resolve) => {
        this.$fetch(api.bms.getDeviceListByPage, {
          // 广播设备类型为26
          deviceType: 26,
          page: 1,
          pageSize: 1000,
        }).then((res) => {
          if (res.success) {
            ((res.returnObj && res.returnObj.list) || []).forEach((item) => {
              let type = "";
              item.status == 0 ? (type = "_grey") : (type = "_inactive");
              // item.status == 0 ? (type = "_outline") : (type = "");
              let addMarkInfo = this.getMapPoint(item, type);
              this.constList.broadcast.push(addMarkInfo);
            });
            resolve(true);
          } else {
            this.$message.error(res.msgContent || "查询广播设备列表失败");
            resolve(true);
          }
        });
      });
    },
    getCameraList() {
      this.constList.camera = [];
      this.$fetch(api.bms.getDeviceListByPage, {
        // 摄像机类型为18
        deviceType: 18,
        isIndoor: 0,
        page: 1,
        pageSize: 2000,
      }).then((res) => {
        if (res.success) {
          let arr = res.returnObj.list;
          this.constList.camera = arr.map((item) => {
            item.tipsTitle = "摄像机详情";
            let azimuth = item.azimuth || 5;
            return {
              id: item.deviceId,
              coord: [Number(item.longitude), Number(item.latitude)],
              anchor: [22, 22],
              scale: 1,
              azimuth: azimuth,
              src: `images/theme/newDark/map/${
                item.statusName == "在线"
                  ? "camera_" + azimuth + ".png"
                  : "camera_gray" + azimuth + ".png"
              }`,
              sleSrc: `images/theme/newDark/map/${
                item.statusName == "在线"
                  ? "camera_" + azimuth + ".png"
                  : "camera_gray" + azimuth + ".png"
              }`,
              attr: item,
              showTips: true,
              upDevice: true,
              tipsMap: {
                deviceName: "摄像机名称",
                areaName: "所属区域",
                statusName: "状态",
                factoryName: "厂家",
                createrTime: "创建时间",
              },
            };
          });
          this.refMap.addMarket(
            this.constList.camera,
            this.constLayerId.camera,
            this.handleMapClick
          );
          if (this.hideCamera) {
            this.refMap.setLayerVisibleById("CAMERA_LAYER", false);
            this.hideCamera = false;
          }
        } else {
          this.$message.error(res.msgContent || "查询摄像机列表失败");
        }
      });
    },
    getMapPoint(item, type = "") {
      let obj = {
        id: item.thirdDeviceId,
        thirdCameraId: item.thirdDeviceId, //为了和设备组设备编号保持一致
        coord: [Number(item.longitude), Number(item.latitude)],
        longitude: +item.longitude,
        latitude: +item.latitude,
        anchor: [22, 22],
        scale: 1,
        isHover: true,
        src: `images/theme/${this.currentTheme}/map/resource/broadcast${type}.png`,
        sleSrc: "images/theme/newDark/map/resource/broadcast-live_selected.png", //选中
        oldSrc: `images/theme/${this.currentTheme}/map/resource/broadcast${type}.png`, //默认图标
        name: item.deviceName,
        tipsTitle: "广播设备详情",
        showTips: true,
        tipsMap: {
          deviceName: "设备名称",
        },
      };
      obj.attr = Object.assign(item, obj);
      return obj;
    },
    getFlickerDrawPoint(flickerDeviceList = []) {
      if (!flickerDeviceList || !flickerDeviceList.length) {
        return;
      }
      let _self = this;
      _self.flickerDrawPoint = [];
      // console.log(flickerDeviceList);
      flickerDeviceList.map((item) => {
        _self.flickerDrawPoint.push({
          id: item.alarmId,
          src: `images/theme/${this.currentTheme}/map/alarm_state/${item.alarmLevel}_1.png`,
          label: item.deviceName,
          alarmLevel: item.alarmLevel,
          coord: [+item.lng, +item.lat],
          alarmId: item.alarmId,
          imgIndex: 0,
          anchor: [42, 42],
          attr: {
            ...item,
          },
        });
      });
      if (this.refMap) {
        // 清除选定图标范围
        this.refMap.removePopup("range_popup");
        this.refMap.addFlashMarket(
          this.flickerDrawPoint,
          this.constLayerId.alarm,
          (e) => {
            this.handleClickAlarm(e.marker.attr);
          }
        );
      }
    },
    // 专注于广播设备打点，因为广播设备与广播喊话，音频播放交互，故打点方法分开
    handleAddMarkBroadcast() {
      // console.log(this.audioDeviceInfo.deviceList);
      // console.log(this.remoteCallInfo.deviceList);
      // console.log(this.constList.broadcast);
      let broadcastList = [];
      this.constList.broadcast.forEach((item) => {
        let obj = { ...item };
        let isAudio = this.audioDeviceInfo.deviceList.some((el) => {
          return el.id == item.id;
        });
        let isCall = this.remoteCallInfo.deviceList.some((el) => {
          return el.id == item.id;
        });
        let checkType = isAudio ? "audio" : isCall ? "call" : ""; //audio:音频播放设备，call:广播喊话设备
        item.checkType = checkType;
        obj.attr.checkType = checkType;
        if (checkType == "audio") {
          obj.src = this.broadcastCheckPlaySrc;
          obj.oldSrc = this.broadcastCheckPlaySrc;
          obj.anchor = [32, 32];
        } else if (checkType == "call") {
          obj.src = this.broadcastCheckSrc;
          obj.oldSrc = this.broadcastCheckSrc;
          obj.anchor = [32, 32];
        }
        broadcastList.push(obj);
      });
      // console.log(broadcastList);
      this.refMap.addMarket(
        broadcastList,
        this.constLayerId.broadcast,
        this.handleMapClick
      );
    },
    // 出入口图层点击事件
    handleMapSceneClick(e) {
      this.$refs.alarmList.isShowList = true; //关闭左侧面板
      this.sceneCode = e.marker.attr.sceneCode;
      this.showGetWayScene = true;
      this.sceneType = 1;
    },
    // 广播，摄像机 图层设备点击back
    handleMapClick(e) {
      console.log("设备点击");
      // console.log(this.broadcastPageType);
      // 创建广播喊话过程中不支持显示提示框
      let deviceType = e.marker.attr.deviceType;
      let checkType = e.marker.attr.checkType;
      if (this.showBroadcast && deviceType == 26) {
        // 远程和广播的设备不可以共用
        if (
          (this.broadcastPageType == 1 && checkType != "audio") ||
          (this.broadcastPageType == 2 && checkType != "call")
        ) {
          this.$refs.refBroadcast.handleDealDevice(e.marker.attr, {
            map: this.refMap,
            layerId: e.layerId,
            id: e.marker.id,
          });
          return;
        }
      }
      const tipID = "device_popup";
      this.refMap.addPopupMap({
        // offset: [-290, -340],
        offset: [0, 0],
        position: e.marker.coord,
        content: '<div id="device_popup"></div>',
        contentId: tipID,
        layerId: tipID,
      });
      let deviceTip = new this.refMap.vueComponents.deviceDetailTip().$mount(
        "#" + tipID
      );
      deviceTip.data = e.marker.attr;
      deviceTip.$on("tipClose", () => {
        this.refMap.removePopup(tipID);
      });
      // 广播喊话
      deviceTip.$on("handleDeviceShout", (info) => {
        this.broadcastPageType = 1;
        this.handleShowBroadcast(e, info, tipID);
      });
      // 广播播放
      deviceTip.$on("handleDeviceMusic", (info) => {
        this.broadcastPageType = 2;
        this.handleShowBroadcast(e, info, tipID);
      });
    },
    handleShowBroadcast(e, info, tipID) {
      this.refMap.removePopup(tipID);
      // 回显点击的设备
      if (this.showBroadcast == true) {
        this.$refs.refBroadcast.handleClosePanel();
        setTimeout(() => {
          this.showBroadcast = true;
          this.$refs.alarmList.isShowList = true; //关闭左侧面板
          this.$refs.refBroadcast.handleDealDevice(info, {
            map: this.refMap,
            layerId: e.layerId,
            id: e.marker.id,
          });
        }, 200);
        return;
      }
      this.$refs.alarmList.isShowList = true; //关闭左侧面板
      this.showBroadcast = true;
      this.$nextTick(() => {
        this.$refs.refBroadcast.handleDealDevice(info, {
          map: this.refMap,
          layerId: e.layerId,
          id: e.marker.id,
        });
      });
    },
    // 从告警详情打开广播喊话,播放音频
    handleOpenBroadcast(info, type) {
      this.handleLayer({ type: 2, value: true }); //展示广播设备
      this.showAlarmTool = true;
      const tipID = "device_popup";
      this.broadcastPageType = type;
      let e = {
        layerId: this.constLayerId.broadcast,
        marker: {
          id: info.thirdDeviceId,
        },
      };
      this.handleShowBroadcast(
        e,
        {
          ...info,
          thirdCameraId: info.thirdDeviceId,
        },
        tipID
      );
    },
    handleCloseFloor(e) {
      if (!this.showBroadcast) {
        this.$refs.alarmList.isShowList = false;
      }
    },
    // 图层楼栋点击back
    handleMapFloorClick(e) {
      let params = {
        pageFlag: false,
        buildingCode: e.marker.attr.buildingCode,
        buildingType: 2, //1楼栋2楼层
      };
      this.$fetch(api.queryBuildingList, params).then((res) => {
        if (res.success) {
          e.marker.attr.floorInfo = res.returnObj;
          this.handleShowFloorTip(e);
        } else {
          this.$message.error(res.msgContent || "查询楼层数据出错");
        }
      });
    },
    // 楼栋弹窗回调
    handleShowFloorTip(e) {
      // console.log(e);
      const floorId = "floorId";
      this.refMap.removePopup();
      this.refMap.addPopupMap({
        offset: [0, 0],
        position: e.marker.coord, // 经纬度
        content: '<div id="floorId"></div>',
        contentId: floorId,
        layerId: floorId,
      });
      let floorTip = null;
      floorTip = new Vue(floorDetails).$mount("#" + floorId);
      let options = e.marker.attr;
      floorTip.options = options;
      floorTip.$on("closeTip", () => {
        this.refMap.removePopup(floorId);
      });
      floorTip.$on("handleOpenDraw", (info) => {
        this.$refs.alarmList.isShowList = true;
        this.$refs.floorDraw.handleOpenPanel(info, options);
      });
    },
    handleIsShowList(val) {
      this.showAlarmTool = val;
    },
    handleMapCenter(info) {
      this.refMap.setMapCenter([+info.longitude, +info.latitude]);
    },
    // 取消告警详情展示
    handleCloseAlarm() {
      this.refMap.removePopup("range_popup");
      this.refMap.setMapCenter();
      this.$refs.alarmList.checkItem = {};
    },
    // 创建告警
    handleAddAlarm() {
      this.showGatePanel = false;
      this.isShowPanel = false;
      this.handleAlarmType = 1;
      if (this.showAddAlarmPanel) {
        this.$refs.handleAlarm.cancelAlarm();
        setTimeout(() => {
          this.showAddAlarmPanel = true;
        }, 300);
      } else {
        this.showAddAlarmPanel = true;
      }
      this.refMap.getLocation((data) => {
        // 如果当前正在创建手动告警，则需要将点位信息填写至手动告警中的告警位置
        if (this.showAddAlarmPanel) {
          const position = [Number(data[0]), Number(data[1])];
          this.$refs.handleAlarm.setAlarmPosition(position.join(","));
          let alarmPosition = [
            {
              id: this.constLayerId.positionMarkerId,
              coord: position,
              anchor: [12, 24],
              src: `images/theme/${this.currentTheme}/map/resource/position_red.png`,
            },
          ];
          this.refMap.addMarket(
            alarmPosition,
            this.constLayerId.positionMarkerId,
            () => {
              // console.log();
            }
          );
        }
      });
    },
    handleCloseAdd(type) {
      this.showAddAlarmPanel = false;
      this.refMap.getLocation(null);
      this.refMap.clearLayer(this.constLayerId.positionMarkerId);
      if (type == true) {
        this.getList(this.page, this.queryParams);
      }
    },
    //告警点击
    handleClickAlarm(item) {
      console.log(item, "告警列表");
      this.showGatePanel = false;
      this.showBroadcast = false;
      this.showAddAlarmPanel = false;
      this.workerOrderList = [];
      this.deviceTableData = [];
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = 20;
      item.alarmMergeFlag == "1"
        ? (this.isMerge = true)
        : (this.isMerge = false);
      this.resetErrorType = item.alarmMergeCode;
      let coord = [+item.lng, +item.lat]; // [118.29584942588806, 35.06289454956055]; //;
      this.refMap.setMapCenter(coord);
      this.refMap.setMapZoom(19);
      //   this.toggleMapResources("18", true);
      let isExpand = this.isShowPanel == true ? true : false;
      this.isShowPanel = false;

      const params = {
        alarmId: item.alarmId,
      };
      this.$fetch(api.alarm.getAlarmDetail, params).then((response) => {
        if (response && response.success) {
          isExpand && item.alarmType != "160101"
            ? setTimeout(() => {
                this.isShowPanel = true;
              }, 300)
            : (this.isShowPanel = true);
          let currentAlarmDetail = response.returnObj;
          this.getDeviceDistance(currentAlarmDetail); //周边设备
          this.alarmType = response.returnObj.alarmType;
          this.emergencyCardList = currentAlarmDetail.emergencyCardList;
          // 是否可以设置联动设备
          if (currentAlarmDetail.reportPersonName) {
            this.shezhiShow = false;
          } else {
            this.shezhiShow = true;
          }
          if (currentAlarmDetail.picFileId) {
            currentAlarmDetail.sourcePic =
              "/common/file/downLoadFileStream.json?fileCode=" +
              currentAlarmDetail.picFileId;
          }
          // 截取vcm的fileId,用于人脸告警大图详情展示
          let uuidIndex =
            currentAlarmDetail.alarmSnapUrl &&
            currentAlarmDetail.alarmSnapUrl.indexOf("fileUuid");
          let index =
            currentAlarmDetail.alarmSnapUrl &&
            currentAlarmDetail.alarmSnapUrl.indexOf("&");
          let fileId =
            currentAlarmDetail.alarmSnapUrl &&
            currentAlarmDetail.alarmSnapUrl.substring(uuidIndex + 9, index);
          // 获取处置工单
          if (
            currentAlarmDetail.alarmState == 4 ||
            currentAlarmDetail.alarmState == 10
          ) {
            this.getWorkerOrder(currentAlarmDetail.taskCode);
          }
          if (currentAlarmDetail.alarmSnapUrl) {
            currentAlarmDetail.pictureList =
              currentAlarmDetail.filePicSourceLists.filter((item) => {
                if (item.picResourceType !== 2) {
                  fileId && this.$set(item, "fileId", fileId);
                  return {
                    resourceCode: item.resourceCode,
                    picResourceType: item.picResourceType,
                  };
                }
              });
            // 手动告警上传视频
            currentAlarmDetail.manuaAlarmPicList =
              currentAlarmDetail.filePicSourceLists.filter((item) => {
                if (item.picResourceType == 2) {
                  return {
                    resourceCode: item.resourceCode,
                    picResourceType: item.picResourceType,
                    resourceName: item.resourceName,
                  };
                }
              });
          }
          this.currentAlarmDetail = { ...currentAlarmDetail };
          // console.log(this.currentAlarmDetail);
          if (item.alarmType == "160101") {
            // 出入口报警
            this.isShowPanel = false;
            this.$refs.alarmList.isShowList = true;
            this.sceneCode = item.alarmDevId;
            this.showGetWayScene = true;
            this.sceneType = 2;
            return;
          }
        } else {
          this.$message.error(
            response.msgContent || this.$t("historyAlarm.message.queryFailed")
          );
        }
      });
    },
    // 绘制告警点范围内设备
    handleDrawCircle(item, distance) {
      // console.log(item);
      const tipID = "range_popup";
      this.refMap.addPopupMap({
        offset: [-distance, -distance],
        position: [item.lng, item.lat],
        content: '<div id="range_popup"></div>',
        contentId: tipID,
        layerId: tipID,
      });
      let rangeTip = new this.refMap.vueComponents.circleRange().$mount(
        "#" + tipID
      );
      // console.log(rangeTip);
      rangeTip.option.width = distance * 2;
      rangeTip.option.height = distance * 2;
    },
    // 查询设备周边列表
    getDeviceDistance(info) {
      let distance = 100;
      this.handleDrawCircle(info, distance);
      let params = {
        pageNum: this.devicePage.currentPage,
        pageSize: this.devicePage.pageSize,
        distance: distance,
        alarmId: info.alarmId,
        deviceTypeList: ["18", "10"], //暂时不查闸机/车道"1", "17"
      };
      this.$fetch(api.alarm.queryAlarmDeviceList, params).then((response) => {
        if (response && response.success) {
          this.deviceTableData = response.returnObj.list || [];
          this.devicePage.total = response.returnObj.total;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    errorClose() {
      this.alarm.processDesc = "";
      this.$refs.dialogForm.resetFields();
      this.errorDialogShow = false;
    },
    errorSubmit() {
      this.$refs.dialogForm.validate((res) => {
        if (res) {
          this.alarm.processDesc = this.formDialog.processDesc;
          this.formDialog.confirmType == 1
            ? this.alarmDispose(2, this.$t("realTimeAlarm.message.confirmSuc"))
            : this.missReport();
        }
      });
    },
    // 批量误报
    resetError(val) {
      val.alarmMergeFlag == "1"
        ? (this.isMerge = true)
        : (this.isMerge = false);
      this.dialogTitle = "误报";
      this.errorDialogShow = true;
      this.resetErrorType = val.alarmMergeCode;
    },
    //单个误报告,type:alarm:告警,scene:出入口
    resetDispose(type) {
      // this.$emit("resetDispose");
      this.disposeType = type;
      this.dialogTitle = "事件结束确认";
      this.errorDialogShow = true;
      this.isMerge = false;
    },
    // 派单成功回调
    handleTaskInfoCallBack(info) {
      this.page.currentPage = 1;
      this.getList(this.page, this.queryParams);
      // this.handleClickAlarm(info);
    },
    // 提交误报
    missReport() {
      this.alarm.alarmId = this.currentAlarmDetail.alarmId;
      this.alarm.alarmState = 3; //3为误报
      if (this.isMerge) {
        // 批量误报
        let params = {
          processDesc: this.alarm.processDesc,
          alarmLevel: this.queryParams.alarmLevel,
          alarmTypeList: this.queryParams.alarmTypeList,
          alarmMergeCode: this.resetErrorType,
          subSystemList: this.queryParams.subSystemList,
          alarmName: this.queryParams.deviceName,
          alarmStartTime: this.queryParams.alarmStartTime,
          alarmEndTime: this.queryParams.alarmEndTime,
        };
        this.$fetch(api.alarm.batchMissReport, params).then((response) => {
          if (response && response.success) {
            this.$message.success(this.$t("realTimeAlarm.message.confirmSuc"));
            this.errorClose();
            this.isShowPanel = false;
            this.page.currentPage = 1;
            this.getList(this.page, this.queryParams);
          } else {
            response.msgContent && this.$message.error(response.msgContent);
          }
        });
        return;
      }
      this.$fetch(api.alarm.missReport, this.alarm).then((response) => {
        if (response && response.success) {
          if (this.disposeType == "scene") {
            this.handleCloseScene();
          }
          this.errorClose();
          this.page.currentPage = 1;
          this.isShowPanel = false;
          this.getList(this.page, this.queryParams);
          this.$message.success(this.$t("realTimeAlarm.message.confirmSuc"));
        } else {
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },
    /*
     *@name:alarmDispose
     *@description: 告警处理
     */
    alarmDispose(state, msg) {
      if (
        this.currentAlarmDetail != null &&
        this.currentAlarmDetail.hasOwnProperty("alarmId")
      ) {
        this.alarm.alarmId = this.currentAlarmDetail.alarmId;
      }
      this.alarm.alarmState = state;
      this.$fetch(api.alarm.updateAlarm, this.alarm).then((response) => {
        if (response && response.success) {
          if (this.disposeType == "scene") {
            // 出入口关闭
            this.handleCloseScene();
          }
          this.errorClose();
          this.isShowPanel = false;
          this.page.currentPage = 1;
          this.getList(this.page, this.queryParams);
          this.$message.success(msg);
        } else {
          this.alarmOption.column[0].disabled = false;
          response.msgContent && this.$message.error(response.msgContent);
        }
      });
    },

    // 告警列表 右击事件
    handRightClick(val, type) {
      this.page.currentPage = 1;
      this.cacheAlarmList = [];
      this.getList(this.page, this.queryParams);
    },
    getList(page, params) {
      Object.assign(this.queryParams, params);
      const _this = this;
      _this.$refs.alarmList.dataLoading = true;
      let subSystemList = this.queryParams.subSystemList.filter((el) => {
        return el != 4 && el != 13 && el != 14;
      });
      this.$fetch(
        api.alarm.getAlarmPageList,
        Object.assign(params, {
          pageNum: page.currentPage,
          pageSize: page.pageSize,
          subSystemList,
        })
      ).then((response) => {
        setTimeout(() => {
          _this.$refs.alarmList.dataLoading = false;
        }, 200);
        if (response && response.success) {
          this.refMap.clearLayer(this.constLayerId.alarm);
          this.refMap.removePopup("range_popup");
          this.$refs.alarmList.alarmMergeFlag =
            response.returnObj.alarmMergeFlag;
          response.returnObj.alarmList.list.forEach((el) => {
            el.isExpand = false;
          });
          if (page.currentPage === 1) {
            _this.cacheAlarmList = [];
          }
          _this.alarmList = response.returnObj
            ? response.returnObj.alarmList.list
            : [];
          if (this.cacheAlarmList.length === 1000) {
            this.cacheAlarmList.splice(0, this.page.pageSize);
          }
          _this.cacheAlarmList = this.cacheAlarmList.concat(_this.alarmList);
          _this.cacheAlarmList = _.orderBy(
            _this.cacheAlarmList,
            ["alarmTime"],
            ["desc"]
          );
          _this.page.total = response.returnObj
            ? response.returnObj.alarmList.total
            : 0;
          _this.levelNums = Object.freeze(
            response.returnObj ? response.returnObj.mapCount : _this.levelNums
          );
          if (_this.cacheAlarmList.length == 0) {
            this.noData = true;
          }
        }
      });
    },
    loadMoreAlarm() {
      this.page.currentPage = this.page.currentPage + 1;
      this.getList(this.page, this.queryParams);
    },
    handleSearchBtn(data) {
      this.initPanel();
      this.cacheAlarmList = [];
      this.page.currentPage = 1;
      let params = {
        alarmLevel: data.alarmLevel || "", //等级
        alarmState: data.alarmState || "", //状态
        alarmStartTime: data.alarmTime && data.alarmTime[0], //开始时间
        alarmEndTime: data.alarmTime && data.alarmTime[1], //结束时间
        // commonAlarmType: data.commonAlarmType || "", //类型
        alarmTypeList:
          data.commonAlarmType.length == 2 ? [data.commonAlarmType[1]] : [], //子系统类型
        subSystemList: data.commonAlarmType.length
          ? [data.commonAlarmType[0]]
          : this.allSubSystemList, //系统
        alarmName: data.alarmName || "", //名称
      };
      this.getList(this.page, params);
    },
    // 设备资源显示控制
    handleShowTool(item) {
      item.isShow = !item.isShow;
      // console.log(item);
      this.refMap.setLayerVisibleById(item.layerId, item.isShow);
    },
    // 单个资源控制
    handleLayer(item) {
      this.alarmToolList[item.type].isShow = item.value;
      this.refMap.setLayerVisibleById(
        this.alarmToolList[item.type].layerId,
        item.value
      );
    },
    // 获取工单
    getWorkerOrder(taskCode) {
      this.$fetch(api.bas.queryTaskInfo, { taskCode: taskCode }).then((res) => {
        if (res.success) {
          this.workerOrderList = Object.freeze(
            res.returnObj.taskExecutionLogList
          );
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    // 关闭出入口场景
    handleCloseScene() {
      this.isShowPanel = false; //隐藏告警详情
      this.sceneCode = "";
      this.sceneType = 1;
      this.showGetWayScene = false; //出入口
      this.showGatePanel = false; //道闸通行记录
      this.$refs.alarmList.isShowList = false; //开启左侧面板
    },
    // 出入口控制闸机通行记录
    handleShowGateDetail() {
      this.showAddAlarmPanel = false;
      this.isShowPanel = false;
      if (this.showBroadcast) {
        this.$refs.refBroadcast.handleClosePanel();
      }
      this.$refs.refGate.gateRecordList = [];
      this.showGatePanel = !this.showGatePanel;
    },
    // 显示隐藏人脸闸机
    handleShowGate() {
      this.showAddAlarmPanel = false;
      this.isShowPanel = false; //隐藏告警详情
      if (this.showBroadcast) {
        // 关闭右侧广播弹窗
        this.$refs.refBroadcast.handleClosePanel();
      }
      this.sceneCode = "";
      this.showGatePanel = !this.showGatePanel;
    },
    // 取消远程喊话弹窗
    handleCloseBroadcast() {
      this.showBroadcast = false;
      this.$refs.alarmList.isShowList = false; //释放左侧列表
      this.handleAddMarkBroadcast();
    },
    // 远程喊话/音频播放成功回调，1 喊话2 音频
    handleSuccessBroadcast(type) {
      if (type == 1) {
        //获取远程喊话
        this.getRemoteCall().then((res) => {
          this.handleAddMarkBroadcast();
        });
      } else {
        //获取播放音频设备
        this.getAudioDevice().then((res) => {
          this.handleAddMarkBroadcast();
        });
      }
      this.showTool = true;
    },
    // 操作远程喊话
    toggleStopIntercom() {
      // console.log(this.remoteCallInfo);
      this.constLoading.call = true;
      let params = {
        // 源终端ID
        sourceTerminalId: this.remoteCallInfo.sourceId,
        // 0 开始 1 停止， 如果当前是开始状态，则修改为'1'（停止）；如果当前是停止状态，则修改为'0'（开始）
        stop: this.remoteCallInfo.processing ? "1" : "0",
        //目标终端ID列表
        targetTerminalIdList: this.remoteCallInfo.deviceList.map((item) => {
          return item.id;
        }),
      };
      this.$fetch(api.manualRemoteCall, params).then((res) => {
        this.constLoading.call = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.getRemoteCall();
        } else {
          this.$message.error(res.msgContent || "操作失败");
        }
      });
    },
    handleVoice(val, list) {
      // console.log(val);
      // console.log(list);
      let params = {
        terminalIdList: list.map((el) => {
          return el.id;
        }),
        volume: val,
      };
      this.$fetch(api.setVolume, params).then((res) => {
        if (res.success) {
          this.$message.success(`声音操作成功`);
        } else {
          this.$message.error(res.msgContent || `声音操作失败`);
        }
      });
    },
    handleClosePlay(type) {
      let url = type == 1 ? api.deleteRemoteCall : api.deletePlayAudio;
      let name = type == 1 ? "远程喊话" : "音频播放";

      this.$confirm("确认关闭" + name + "？", "确认关闭", {
        type: "warning",
      })
        .then((res) => {
          this.$fetch(url).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              let deviceList =
                type == 1
                  ? this.remoteCallInfo.deviceList
                  : this.audioDeviceInfo.deviceList;
              this[type == 1 ? "remoteCallInfo" : "audioDeviceInfo"] = {
                deviceList: [],
                isEmpty: false,
              };
              // 恢复之前选中的广播
              this.handleAddMarkBroadcast();
            } else {
              this.$message.error(res.msgContent || "操作失败");
            }
          });
        })
        .catch((e) => {
          this.$log.debug("用户取消操作");
        });
    },
    // 控制音频播放
    controlPlayAudio(controlType) {
      let optStr = {
        play: "恢复播放",
        pause: "暂停播放",
        next: "音频播放下一首",
        previous: "音频播放上一首",
      };
      let params = {
        // 控制类型： play: 播放 pause: 暂停 next: 下一首 previous: 上一首
        controlType: controlType,
        // 播放状态 startbct(开始广播) stopbct（停止广播）filecontrol （ 播放控制）  此接口固定传filecontrol（ 播放控制）
        rtType: "filecontrol",
        // 广播ID列表
        terminalIdList: this.audioDeviceInfo.deviceList.map((item) => {
          return item.id;
        }),
      };
      this.$fetch(api.controlPlayAudio, params).then((res) => {
        if (res.success) {
          this.$message.success(`${optStr[controlType]}成功`);
          this.getAudioDevice();
        } else {
          this.$message.error(res.msgContent || `${optStr[controlType]}失败`);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.font-18 {
  font-size: 18px;
}

.font-24 {
  font-size: 24px;
}

.font-40 {
  font-size: 40px;
}

.realTimeAlarm-page {
  .alarmTool {
    height: 80px;
    position: absolute;
    top: 50px;
    left: 90px;
    z-index: 2;
    display: flex;
    align-items: center;
    transition: left 0.3s;

    &.show {
      left: 440px !important;
    }
  }

  .alarmTool-btn {
    min-width: 90px;
    margin: 0 10px;

    button {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      @include set_theme_color(background-color, page-bg-color);
      border: 2px solid #3e76e6;
    }
  }

  .alarmTool-broadcast {
    color: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
  }

  .alarmTool-call {
    height: 30px;
    padding: 0 10px;
    // width: 650px;
    @include set_theme_color(background-color, map-panel);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: 2;

    &.intercom {
      top: 10px;
    }

    &.play {
      bottom: 10px;
    }

    .intercom-title {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 150px;
    }

    .intercom-device {
      max-width: 200px;
      // margin-right: 10px;
      // padding-right: 10px;
      position: relative;

      .intercom-device-item {
        display: flex;
        flex-direction: row;
        padding: 7px 10px;
        width: 165px;
      }

      .device-expand-icon {
        @include set_animation(transform);

        &.expand {
          transform: rotate(180deg);
        }
      }

      .device-list-area {
        position: absolute;
        overflow: hidden;
        max-height: 180px;
        left: 0;
        width: 100%;
        @include set_theme_color(background-color, popper-bg-color);
        @include set_animation(height);

        &.hidden {
          height: 0 !important;
        }

        &.top {
          bottom: 30px;
        }

        &.bottom {
          top: 30px;
        }
      }
    }

    .device-name,
    .audio-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 0 5px;
    }

    .intercom-operate {
      width: 100px;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-size: 20px;

      &.has-bg {
        padding: 5px;
        border-radius: 3px;
        // @include set_theme_color(background-color, page-tab-item-active-color);
      }

      .operate-btn {
        display: flex;
        flex-direction: row;
      }

      .stop-icon {
        padding: 2px;
        // height: 16px;
        // width: 16px;
        border-radius: 9px;
        background-color: #ff0000;
      }

      .play-icon {
        padding: 2px;
        border-radius: 9px;
        background-color: green;
      }

      .operate-text {
        margin-left: 5px;
      }
    }

    .intercom-volume {
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: not-allowed;
    }

    .intercom-volume-bar {
      width: 0;
      margin-right: 5px;
      overflow: hidden;
      @include set_animation(width);

      .el-slider {
        margin: 0 10px;
      }

      &.active {
        width: 100px;
      }
    }

    .intercom-close {
      height: 30px;
      width: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .click-able {
      cursor: pointer;

      &:hover {
        @include set_theme_color(color, main-theme-color);
      }
    }
  }

  .alarmTool-list {
    transition: all 500ms linear;

    .inactive {
      background: url("../images/inactive-bg.png");
    }

    .active {
      color: #fff;
      border-radius: 5px;
      background: url("../images/active-bg.png");
    }

    img {
      width: 38px;
      margin: auto;
    }

    &_camera,
    &_getway,
    &_broadcast {
      width: 80px;
      height: 80px;
      line-height: 25px;
      text-align: center;
      cursor: pointer;

      i {
        text-align: center;
        line-height: 78px;
      }
    }
  }
}
</style>
